module.exports = __webpack_public_path__ + "static/img/avatar.693d8c6a.png";